import * as actionTypes from '../actions/Actions'

export const openLoadingApi = () => ({type: actionTypes.OPEN_LOADING_API});
export const closeLoadingApi = () => ({type: actionTypes.CLOSE_LOADING_API});